// i18n
import { i18n } from '@ecg-marktplaats/js-react-i18n';
import { nl as dateLocale } from 'date-fns/locale/nl';
import translation from '../../../../locales/nl-NL/translation.json';
import common from '../../../../locales/nl-NL/common.json';
import priceTypes from '../../../../locales/nl-NL/priceTypes.json';
import p2pPaymentsUi from '@ecg-internal/p2p-payments-ui/locales/nl-NL.json';
import reviewsDialogUi from '@ecg-internal/reviews-dialog-ui/locales/nl-NL.json';
import favouritesUi from '@ecg-internal/favourites-ui/locales/nl-NL.json';

export default i18n.init({
  lng: 'nl-NL',
  dateLocale,
  translations: {
    translation,
    common,
    priceTypes,
    p2pPaymentsUi,
    reviewsDialogUi,
    favouritesUi,
  },
});
